import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ArrowUpward as ArrowUpwardIcon } from '@mui/icons-material';

import { Fab } from '@mui/material';

import './BackToTop.css';

class BackToTop extends Component {
  render() {
    return (
      <Fab
        size="small"
        onClick={this.props.onTapBackToTop}
        color="primary"
        style={{
          margin: 0,
          top: 'auto',
          left: '97%',
          bottom: 20,
          right: 'auto',
          position: 'fixed',
        }}
      >
        <ArrowUpwardIcon />
      </Fab>
    );
  }
}

BackToTop.propTypes = {
  onTapBackToTop: PropTypes.func.isRequired,
};

export default BackToTop;
